import React from 'react'
import './Organizator.scss'
import { companyInfo, getLinkYandexMetrikaCode, Socials } from "src/components/Organizator/utils"
import { Link } from "react-router"
import Paragraph from "src/components/Paragraph/Paragraph"
import { AppCompaniesChoices } from "src/types"
import CompanyLogo from "src/components/CompanyLogo/CompanyLogo"
import ym from "react-yandex-metrika"
import { runTypograph } from "src/helpers"

interface IOrganizator {
    company: keyof typeof AppCompaniesChoices
}

const Organizator: React.FC<IOrganizator> = (props) => {
    const { company } = props
    const { description, socials, fontColor } = companyInfo[company]

    return (
        <div className={`organizator organizator--${company}`}>
            <CompanyLogo
                className="organizator__logo"
                name={AppCompaniesChoices[company]}
                mode={"main"}
            />
            <div className="organizator__image">
                <picture>
                    <source srcSet={`/slider/${company}-image-desktop.png`} media="(min-width: 1280px)"/>
                    <img src={`/slider/${company}-image-mobile.png`} alt="Описание изображения"/>
                </picture>
            </div>
            <Paragraph variant={1} className={`organizator__description ${fontColor}`}>
                {runTypograph(description)}
            </Paragraph>
            <div className="organizator__socials">
                {
                    Object.entries(socials)
                        .filter(([, value]) => Boolean(value))
                        .map(([key, value]) => {
                            return (
                                <Link
                                    key={value}
                                    to={value}
                                    className={`h3 organizator__link organizator__link--${fontColor}-75`}
                                    target={"_blank"}
                                    onClick={() => {

                                        ym("reachGoal", getLinkYandexMetrikaCode(company, key as Socials))
                                    }}
                                >
                                    {key}
                                    <img src={"/misc/arrow.svg"} alt=""/>
                                </Link>
                            )
                        })
                }
            </div>
        </div>
    )
}

export default Organizator